import { create } from 'zustand';

const useUserStore = create((set) => ({
    affiliateId: null,
    isLoading: true,
    setAffiliateId: (affiliateId) => set({ affiliateId }),
    setIsLoading: (isLoading) => set({ isLoading }),
}));

export default useUserStore;
